// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import type {Switch} from './index';

export function template(this: Switch) {
  const disabled = this.attr(`disabled`);
  const on = this.attr(`on`);
  const icon = this.attr(`icon`) ? this.attr(`icon`) : `checkmark`;

  return (
    <div
      sel='.mp-switch'
      class={{
        'switch-on': on,
        'switch-off': !on,
        disabled,
      }}
      on={{
        click: disabled ? null : this.helpers.toggleSwitch,
      }}
    >
      <SvgIconEl attrs={{icon}} class={{'show-icon-while-off': this.attr(`show-icon-while-off`)}} />
    </div>
  );
}
